import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Roles = () => {
        const permissionsList = useSelector((state) => state?.pagePermissions?.permissions || []);

    const [allRoles, setAllRoles] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleAdd = () => {
        navigate('/add-role');
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                                        {permissionsList?.updateAllowed === 'Y' && (

                    <Button
                        tooltip="Edit"
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                        onClick={() => {
                            navigate('/edit-role', { state: { rowData } });
                        }}
                        className="p-button-rounded p-button-primary mr-2 ml-2"
                    />)}
                                        {permissionsList?.viewAllowed === 'Y' && (

                    <Button
                        tooltip="View"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        onClick={() => {
                            navigate('/view-role', { state: { rowData } });
                        }}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />)}
                </div>
            </>
        );
    };

    const getRoleList = async () => {
        const response = await handleGetRequest(endPoints.getallRoles, true, false, dispatch);
        if (response) {
            setAllRoles(response?.data);
        }
    };

    useEffect(() => {
        getRoleList();
    }, []);

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Roles</h3>
                <div className="flex gap-2">
                    {permissionsList?.insertAllowed === 'Y' &&
                    <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} />}
                </div>
            </div>

            <DataTable
                paginator
                rows={15}
                rowsPerPageOptions={[5, 10, 20]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                emptyMessage="No List found."
                responsiveLayout="scroll"
                value={allRoles}
                className="p-datatable-sm datatable-responsive"
            >
                <Column field="roleName" header="Role Name" />
                <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        </div>
    );
};

export default Roles;
